import { useLocale } from 'next-intl'
import { ComponentProps, useCallback } from 'react'

import {
  formatDate,
  formatDateRange,
  formatDateWithDayOfWeek,
  parseDateRange,
} from '@/shared/lib'

export const useFormatDate = () => {
  const locale = useLocale()

  const formatLocaleDate = useCallback(
    ({ date, format }: ComponentProps<typeof formatDate>) => {
      return formatDate({ date, format, locale })
    },
    [locale],
  )

  const formatLocaleDateRange = useCallback(
    ({ dateRange, format }: ComponentProps<typeof formatDateRange>) => {
      return formatDateRange({ dateRange, format, locale })
    },
    [locale],
  )

  const formatLocaleDateWithDayOfWeek = useCallback(
    ({ date, format }: ComponentProps<typeof formatDateWithDayOfWeek>) => {
      return formatDateWithDayOfWeek({ date, format, locale })
    },
    [locale],
  )

  const parseLocaleDateRange = useCallback(
    ({ dateRange, format }: { dateRange?: string; format?: string }) => {
      return parseDateRange({ dateRange, format, locale })
    },
    [locale],
  )

  return {
    formatDate: formatLocaleDate,
    formatDateRange: formatLocaleDateRange,
    formatDateWithDayOfWeek: formatLocaleDateWithDayOfWeek,
    parseDateRange: parseLocaleDateRange,
  }
}
